export const COLUMNS = [
    {
        Header: 'Weapons System',
        accessor: 'weaponsSystem'
    },
    {
        Header: 'Exam Date',
        accessor: 'examDate'
    },
    {
        Header: 'Tutors',
        accessor: 'teachers'
    },
    {
        Header: 'Details',
        accessor: 'details'
    }
]